module.exports = __webpack_public_path__ + "assets/minus_grey-47a7af.svg";